<template>
    <v-app>
        <Head>
            <title>{{ $t('campaign_version_three.meta_title') }}</title>
            <meta name="description" :content="$t('campaign_version_three.meta_description')">
        </Head>
<!--        <v-app-bar color="primary" :height="40" absolute>-->
<!--            <v-row justify="center">-->
<!--                <v-col>-->
<!--                    <div class="text-body-2 font-weight-bold text-center" v-html="$t('campaign_version_three.header_top')"></div>-->
<!--                </v-col>-->
<!--            </v-row>-->
<!--        </v-app-bar>-->
        <v-main>
            <v-container :fluid="true">
                <v-row justify="center" class="bg-white-gradient ma-n4">
                    <v-col class="max-width">
                        <ListImageWidget/>
                    </v-col>
                </v-row>
                <v-row justify="center" class="bg-primary-gradient ma-n4 custom-padding">
                    <v-col class="max-width">
                        <calculator-stepper
                            :locale="locale"
                            :all-inverters="allInverters"
                            :solar-panel-id="solarPanelId"
                            :all-solar-panels="allSolarPanels"
                            :base-margins="baseMargins"
                            :all-batteries="allBatteries"
                            :minimum-company-margins="minimumCompanyMargins"
                            :price-factors="priceFactors"
                            :roof-sheathings="roofSheathings"
                        />
                    </v-col>
                </v-row>
                <v-row justify="center" class="pt-8">
                    <v-col class="max-width">
                        <Graph/>
                    </v-col>
                </v-row>
                <v-row justify="center" class="bg-surface">
                    <v-col class="max-width">
                        <v-row justify="center">
                            <v-col cols="11">
                                <GoogleReviews/>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import ListImageWidget from "../../Components/Campaigns/ListImageWidget";
import GoogleReviews from "../../Components/Campaigns/GoogleReviews";
import CalculatorStepper from "../../Components/Campaigns/CalculatorStepper";
import Graph from "../../Components/Campaigns/Graph";
import {useTheme} from "vuetify";
import { Head } from "@inertiajs/inertia-vue3";

export default  {
    name:"VersionThree",
    components: {
        ListImageWidget,
        GoogleReviews,
        CalculatorStepper,
        Graph,
        // Head
    },
    props: {
        locale: {
            type: String,
            required: true,
        },
        roofSheathings: {
            type: Array,
            required: true,
        },
        allSolarPanels: {
            type: Array,
            required: true,
        },
        allInverters: {
            type: Array,
            required: true,
        },
        allBatteries: {
            type: Array,
            required: true,
        },
        priceFactors: {
            type: Array,
            required: true,
        },
        minimumCompanyMargins: {
            type: Array,
            required: true,
        },
        baseMargins: {
            type: Array,
            required: true,
        },
        showOffers: {
            type: Boolean,
            required: true,
        },
        solarPanelId: {
            type: Number,
            required: true,
        },
        errors: {
            type: Object,
            required: false,
        },
        auth: {
            type: Object,
            required: false,
        },
    },
    created() {
        let theme = useTheme();
        theme.global.name.value = 'CampaignTheme3';
    }
}
</script>

<style lang="scss">

body {
    font-family: Poppins !important;
}

.max-width {
    @media (min-width: 500px) {
        max-width: 500px;
    }
}
.bg-primary-gradient {
    background: linear-gradient(180deg, #0C1C74 -13.92%, #3249C6 37.03%), #1D34AA;
}
.bg-white-gradient {
    background: linear-gradient(180deg, #F7F8F8 0%, #E2E2E3 100%);
}
.custom-padding {
    padding-top: 100px;
}
.text-transform-none {
    text-transform: none!important;
    letter-spacing: normal!important;
}
.graph-y {
    position: absolute;
    left: 0;
    white-space: nowrap;
}
.graph-x-0 {
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
    border-bottom: 1px solid #959BB5;
}
.graph-y-dashed {
    position: absolute;
    left: 0;
    width: 100%;
    border-bottom: 1px dashed #CFD6EA;
}
.graph-other {
    position: absolute;
    background: #A0A9C2;
    left: 5%;
    width: 40%;
}
.graph-first{
    bottom: 0;
    border-bottom-left-radius: 0!important;
    border-bottom-right-radius: 0!important;
}
.graph-nova {
    position: absolute;
    background: #334AC6;
    left: 55%;
    width: 40%;
}
</style>
